// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"video-source_wrapper__Gpw5n","wrapper__text":"video-source_wrapper__text__ZM1nG"};